import {theme} from "../../../../utils";

export const mobileStyles = {
    hamburgerIcon: {
        width: "18px",
        height: "12px",
        marginBottom: "1px",
        marginRight: "9px",
    }
}


export const styles = {
    headerWrapper: {
        px: "10px",
        pt: "10px",
        boxShadow: '0px 1px 5px 0px rgba(37, 37, 37, 0.12), 0px 2px 2px 0px rgba(37, 37, 37, 0.14), 0px 3px 1px -2px rgba(37, 37, 37, 0.20)'
    },
    mainToolbar: {
        display: "flex",
        justifyContent: "space-between"
    },
    appLogo:{
        zIndex: 11,
        display: "flex",
        flexDirection: "row",
        alignItems: 'center',
        justifyContent: "center",
        py: '22px'
    },
    subHeaderText: {
        ...theme.typography.poppinsBodyBold,
        fontSize: "16px",
        color: "#1E1E22"
    },
    menuItemText: {
        ...theme.typography.poppinsBodyBold,
        fontSize: "16px",
        fontWeight: 500,
        color: "#1E1E22",
        mt: "12px"
    },
    profile: {
        container: {
            display: "flex",
            alignItems: "center",
            zIndex: 11
        },
        slotProps: {
            paper: {
                elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        width: 280,
                        px: "10px",
                        py: "27px",
                        borderRadius: "8px"
                    },
            },
        },
        closeProfileButton: {
            width: "34px",
            height: "34px",
            position: "absolute",
            right: 0,
            top: 0,
        },
        avatarContainer: {
            height: "40px",
            width: "40px",
            borderRadius: "30px",
            border: "1px solid black",
            padding: "2px"
        },
        avatarImage: {
            height: "40px",
            width: "40px",
        },
        userNameWrapper: {
            ml: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start"
        },
        username: {
            ...theme.typography.poppinsBodyBold,
            fontSize: "1rem"
        },
        specialtyName: {
            ...theme.typography.poppinsBodyRegular,
            color: "#777676"
        }
    }
}